import React from "react";
import { ATTACHMENT_STATUS, DOC_TYPES, DOC_TYPE_UNKNOWN } from "@/lib/attachmentConstants";
import { cn } from "@/lib/utils";

const base = "inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap";
const sizes = { sm: "px-2.5 py-1 text-xs", md: "px-3 py-1.5 text-sm" };

export const DocTypeBadge = ({ docType, size = "sm", short = false, className }) => {
  const cfg = DOC_TYPES[docType] || DOC_TYPE_UNKNOWN;
  const Icon = cfg.icon;
  return (
    <span className={cn(base, sizes[size], cfg.className, className)} data-testid={`doctype-badge-${docType || "ukjent"}`}>
      <Icon className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
      {short ? cfg.short : cfg.label}
    </span>
  );
};

export const AttachmentStatusBadge = ({ status, size = "sm", className }) => {
  const cfg = ATTACHMENT_STATUS[status] || ATTACHMENT_STATUS.ny;
  const Icon = cfg.icon;
  return (
    <span className={cn(base, sizes[size], cfg.className, className)} data-testid={`attachment-status-${status}`}>
      <Icon className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} />
      {cfg.label}
    </span>
  );
};
